<template>
  <div class="container">
    <lk-card class="mb16" title="验收成本调整" v-if="checkCostData.length > 0">
      <lk-table border :columns="columns3" :data="checkCostData"></lk-table>
      <p class="total">
        变动总计：含税金额 {{info.financeCostChangeInspectionTotalVo ? info.financeCostChangeInspectionTotalVo.amountWithTax : 0}}&nbsp;&nbsp;
        不含税金额 {{info.financeCostChangeInspectionTotalVo ? info.financeCostChangeInspectionTotalVo.amountWithoutTax : 0}}&nbsp;&nbsp;
        税额 {{info.financeCostChangeInspectionTotalVo ? info.financeCostChangeInspectionTotalVo.tax : 0}}
      </p>
    </lk-card>
    <lk-card class="mb16" title="销售成本调整" v-if="saleCostData.length > 0">
      <lk-table border :columns="columns1" :data="saleCostData"></lk-table>
      <p class="total">
        变动总计：含税金额 {{info.financeCostChangeSaleTotalVo ? info.financeCostChangeSaleTotalVo.amountWithTax : 0}}&nbsp;&nbsp;
        不含税金额 {{info.financeCostChangeSaleTotalVo ? info.financeCostChangeSaleTotalVo.amountWithoutTax : 0}}&nbsp;&nbsp;
        税额 {{info.financeCostChangeSaleTotalVo ? info.financeCostChangeSaleTotalVo.tax : 0}}
      </p>
    </lk-card>
    <lk-card class="mb16" title="其他成本调整" v-if="otherCostData.length > 0">
      <lk-table border :columns="columns4" :data="otherCostData"></lk-table>
      <p class="total">
        变动总计：含税金额 {{info.financeCostChangeOtherTotalVo ? info.financeCostChangeOtherTotalVo.amountWithTax : 0}}&nbsp;&nbsp;
        不含税金额 {{info.financeCostChangeOtherTotalVo ? info.financeCostChangeOtherTotalVo.amountWithoutTax : 0}}&nbsp;&nbsp;
        税额 {{info.financeCostChangeOtherTotalVo ? info.financeCostChangeOtherTotalVo.tax : 0}}
      </p>
    </lk-card>
    <lk-card class="mb16" title="无法分摊调节小数" v-if="notDivideData.length > 0">
      <lk-table border :columns="columns2" :data="notDivideData"></lk-table>
    </lk-card>
  </div>
</template>

<script>
import utils from '@/libs/utils';

export default {
  components: { },
  props: {
    info: {
      type: Object,
    },
    financePayableCreateType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      // 销售成本调整
      saleCostData: [],
      // 无法分摊调节小数
      notDivideData: [],
      // 验收成本调整
      checkCostData: [],
      // 其他成本调整
      otherCostData: [],
      referTypeMap: {
        1: '验收',
        2: '退货',
        3: '召回',
      },
      financeCostChangeTypeList: [
        '验收入库',
        '供应商退货',
        '销售出库',
        '销售退货',
        '报损出库',
        '盘盈入库',
        '盘亏出库',
      ],
      columns1: [
        { title: '序号', type: 'index', minWidth: 116 },
        {
          title: '单据类型',
          key: 'financeCostChangeSaleFinanceCostChangeType',
          minWidth: 116,
          render: (h, params) => h('span', this.financeCostChangeTypeList[params.row.financeCostChangeSaleFinanceCostChangeType - 1]),
        },
        { title: '单号', key: 'financeCostChangeSaleReferCode', minWidth: 116 },
        {
          title: '创建日期',
          key: 'financeCostChangeSaleReferCreateTime',
          minWidth: 144,
          render: (h, params) => h('span', utils.exchangeTime(params.row.financeCostChangeSaleReferCreateTime)),
        },
        { title: '商品名称', key: 'goodsInfoVoApprovedDrugName', minWidth: 130 },
        { title: '规格', key: 'goodsInfoVoSpec', minWidth: 116 },
        { title: '生产厂家', key: 'goodsInfoVoProducer', minWidth: 116 },
        { title: '包装单位', key: 'goodsInfoVoDrugMiniPackageUnitString', minWidth: 116 },
        { title: '批次', key: 'inventoryInfoGoodsBatchSeq', minWidth: 116 },
        { title: '批号', key: 'inventoryInfoGoodsBatchNumber', minWidth: 116 },
        { title: '库+货位', key: 'warehouseNameAndLocationCode', minWidth: 116 },
        { title: '数量', key: 'num', minWidth: 116 },
        { title: '原含税成本金额', key: 'financeCostChangeSaleOriginalCostAmountWithTax', minWidth: 130 },
        { title: '原税率', key: 'financeCostChangeSaleOriginalTaxRate', minWidth: 116 },
        { title: '原不含税金额', key: 'financeCostChangeSaleOriginalCostAmountWithoutTax', minWidth: 116 },
        { title: '原税额', key: 'financeCostChangeSaleOriginalTax', minWidth: 116 },
        { title: '确认含税金额', key: 'financeCostChangeSaleRealAmountWithTax', minWidth: 116 },
        { title: '确认税率', key: 'financeCostChangeSaleRealTaxRate', minWidth: 116 },
        { title: '确认不含税金额', key: 'financeCostChangeSaleRealAmountWithoutTax', minWidth: 130 },
        { title: '确认税额', key: 'financeCostChangeSaleRealTax', minWidth: 116 },
        { title: '调整含税金额', key: 'financeCostChangeSaleAdjustAmountWithTax', minWidth: 116 },
        { title: '调整不含税金额', key: 'financeCostChangeSaleAdjustAmountWithoutTax', minWidth: 130 },
        { title: '调整税额', key: 'financeCostChangeSaleAdjustTax', minWidth: 116 },
      ],
      // 无法分摊调节小数
      columns2: [
        { title: '序号', type: 'index', minWidth: 116 },
        { title: '系统确认不含税总金额', key: 'totalPriceWithoutTax', minWidth: 170 },
        { title: '系统确认税额', key: 'totalTax', minWidth: 140 },
        { title: '系统确认总金额', key: 'totalPriceWithTax', minWidth: 140 },
        { title: '发票不含税金额', key: 'invoiceAmountWithoutTax', minWidth: 126 },
        { title: '发票税额', key: 'invoiceTotalTax', minWidth: 116 },
        { title: '发票总金额', key: 'invoiceAmount', minWidth: 116 },
        { title: '不含税差额', key: 'amountWithoutTaxBalance', minWidth: 116 },
        { title: '税差', key: 'taxBalance', minWidth: 116 },
      ],
      // 验收成本调整
      columns3: [
        { title: '序号', type: 'index', minWidth: 116 },
        {
          title: '单据类型',
          key: 'financeCostChangeInspectionFinanceCostChangeType',
          minWidth: 116,
          render: (h, params) => h('span', this.financeCostChangeTypeList[params.row.financeCostChangeInspectionFinanceCostChangeType - 1]),
        },
        { title: '单号', key: 'financeCostChangeInspectionInspectionCode', minWidth: 116 },
        {
          title: '创建日期',
          key: 'financeCostChangeInspectionReferCreateTime',
          minWidth: 144,
          render: (h, params) => h('span', utils.exchangeTime(params.row.financeCostChangeInspectionReferCreateTime)),
        },
        { title: '商品名称', key: 'inventoryInfoApprovedDrugNames', minWidth: 130 },
        { title: '规格', key: 'inventoryInfoSpecifications', minWidth: 116 },
        { title: '生产厂家', key: 'inventoryInfoManufacturer', minWidth: 116 },
        { title: '包装单位', key: 'inventoryInfoDrugMiniPackageUnit', minWidth: 116 },
        { title: '批次', key: 'inventoryInfoGoodsBatchSeq', minWidth: 116 },
        { title: '批号', key: 'inventoryInfoGoodsBatchNumber', minWidth: 116 },
        { title: '库+货位', key: 'warehouseNameAndLocationCode', minWidth: 116 },
        { title: '数量', key: 'financeCostChangeInspectionNum', minWidth: 116 },
        { title: '原含税金额', key: 'financeCostChangeInspectionOriginalCostAmountWithTax', minWidth: 130 },
        { title: '原税率', key: 'financeCostChangeInspectionOriginalTaxRate', minWidth: 116 },
        { title: '原不含税金额', key: 'financeCostChangeInspectionOriginalCostAmountWithoutTax', minWidth: 116 },
        { title: '原税额', key: 'financeCostChangeInspectionOriginalTax', minWidth: 116 },
        { title: '确认含税金额', key: 'financeCostChangeInspectionRealAmountWithTax', minWidth: 116 },
        { title: '确认税率', key: 'financeCostChangeInspectionRealTaxRate', minWidth: 116 },
        { title: '确认不含税金额', key: 'financeCostChangeInspectionRealAmountWithoutTax', minWidth: 130 },
        { title: '确认税额', key: 'financeCostChangeInspectionRealTax', minWidth: 116 },
        { title: '调整含税金额', key: 'financeCostChangeInspectionAdjustAmountWithTax', minWidth: 116 },
        { title: '调整不含税金额', key: 'financeCostChangeInspectionAdjustAmountWithoutTax', minWidth: 130 },
        { title: '调整税额', key: 'financeCostChangeInspectionAdjustTax', minWidth: 116 },
      ],
      // 其他成本调整
      columns4: [
        { title: '序号', type: 'index', minWidth: 116 },
        {
          title: '单据类型',
          key: 'financeCostChangeOtherFinanceCostChangeType',
          minWidth: 116,
          render: (h, params) => h('span', this.financeCostChangeTypeList[params.row.financeCostChangeOtherFinanceCostChangeType - 1]),
        },
        { title: '单号', key: 'financeCostChangeOtherReferCode', minWidth: 116 },
        {
          title: '创建日期',
          key: 'financeCostChangeOtherReferCreateTime',
          minWidth: 144,
          render: (h, params) => h('span', utils.exchangeTime(params.row.financeCostChangeOtherReferCreateTime)),
        },
        { title: '商品名称', key: 'goodsInfoVoApprovedDrugName', minWidth: 130 },
        { title: '规格', key: 'goodsInfoVoSpec', minWidth: 116 },
        { title: '生产厂家', key: 'goodsInfoVoProducer', minWidth: 116 },
        { title: '包装单位', key: 'goodsInfoVoDrugMiniPackageUnitString', minWidth: 116 },
        { title: '批次', key: 'inventoryInfoGoodsBatchSeq', minWidth: 116 },
        { title: '批号', key: 'inventoryInfoGoodsBatchNumber', minWidth: 116 },
        { title: '库+货位', key: 'warehouseNameAndLocationCode', minWidth: 116 },
        { title: '数量', key: 'financeCostChangeOtherNum', minWidth: 116 },
        { title: '原含税成本金额', key: 'financeCostChangeOtherOriginalCostAmountWithTax', minWidth: 130 },
        { title: '原税率', key: 'financeCostChangeOtherOriginalTaxRate', minWidth: 116 },
        { title: '原不含税金额', key: 'financeCostChangeOtherOriginalCostAmountWithoutTax', minWidth: 116 },
        { title: '原税额', key: 'financeCostChangeOtherOriginalTax', minWidth: 116 },
        { title: '确认含税金额', key: 'financeCostChangeOtherRealAmountWithTax', minWidth: 116 },
        { title: '确认税率', key: 'financeCostChangeOtherRealTaxRate', minWidth: 116 },
        { title: '确认不含税金额', key: 'financeCostChangeOtherRealAmountWithoutTax', minWidth: 130 },
        { title: '确认税额', key: 'financeCostChangeOtherRealTax', minWidth: 116 },
        { title: '调整含税金额', key: 'financeCostChangeOtherAdjustAmountWithTax', minWidth: 116 },
        { title: '调整不含税金额', key: 'financeCostChangeOtherAdjustAmountWithoutTax', minWidth: 130 },
        { title: '调整税额', key: 'financeCostChangeOtherAdjustTax', minWidth: 116 },
      ],
    };
  },
  watch: {
    financePayableCreateType: {
      handler(val) {
        this.columns2.forEach((item) => {
          if (item.key == 'totalPriceWithoutTax') {
            item.title = val != 2 ? '系统确认不含税总金额' : '系统待抵消不含税总金额';
          } else if (item.key == 'totalTax') {
            item.title = val != 2 ? '系统确认税额' : '系统待抵消税额';
          } else if (item.key == 'totalPriceWithTax') {
            item.title = val != 2 ? '系统确认总金额' : '系统待抵消总金额';
          }
        });
      },
      immediate: true,
    },
    info: {
      handler(val) {
        this.handlerInfo(val);
      },
      deep: true,
    },
  },
  computed: { },
  methods: {
    handlerInfo(temp) {
      // 销售成本调整
      if (temp.financeCostChangeSaleVoList) {
        temp.financeCostChangeSaleVoList.forEach((item) => {
          const result = {};
          utils.exchangeTable(item, result);
          result.warehouseNameAndLocationCode = `${result.inventoryInfoWarehouseName}-${result.inventoryInfoLocationCode}`;
          result.financeCostChangeSaleOriginalTaxRate = result.financeCostChangeSaleOriginalTaxRate ? `${result.financeCostChangeSaleOriginalTaxRate}%` : '0%';
          result.financeCostChangeSaleRealTaxRate = result.financeCostChangeSaleRealTaxRate ? `${result.financeCostChangeSaleRealTaxRate}%` : '0%';
          this.saleCostData.push(result);
        });
      } else {
        this.saleCostData = [];
      }
      // 无法分摊调节小数
      if (temp.financeCostChangeAmount) {
        this.notDivideData = [temp.financeCostChangeAmount];
      } else {
        this.notDivideData = [];
      }
      // 验收成本调整
      if (temp.financeCostChangeInspectionVoList) {
        temp.financeCostChangeInspectionVoList.forEach((item) => {
          const result = {};
          utils.exchangeTable(item, result);
          result.warehouseNameAndLocationCode = `${result.inventoryInfoWarehouseName}-${result.inventoryInfoLocationCode}`;
          result.financeCostChangeInspectionOriginalTaxRate = result.financeCostChangeInspectionOriginalTaxRate ? `${result.financeCostChangeInspectionOriginalTaxRate}%` : '0%';
          result.financeCostChangeInspectionRealTaxRate = result.financeCostChangeInspectionRealTaxRate ? `${result.financeCostChangeInspectionRealTaxRate}%` : '0%';
          this.checkCostData.push(result);
        });
      } else {
        this.checkCostData = [];
      }
      // 其他成本调整
      if (temp.financeCostChangeOtherVoList) {
        temp.financeCostChangeOtherVoList.forEach((item) => {
          const result = {};
          utils.exchangeTable(item, result);
          result.warehouseNameAndLocationCode = `${result.inventoryInfoWarehouseName}-${result.inventoryInfoLocationCode}`;
          result.financeCostChangeOtherOriginalTaxRate = result.financeCostChangeOtherOriginalTaxRate ? `${result.financeCostChangeOtherOriginalTaxRate}%` : '0%';
          result.financeCostChangeOtherRealTaxRate = result.financeCostChangeOtherRealTaxRate ? `${result.financeCostChangeOtherRealTaxRate}%` : '0%';
          this.otherCostData.push(result);
        });
      } else {
        this.otherCostData = [];
      }
    },
  },
  mounted() { },
  created() { },
};
</script>

<style scoped>
  .cardContainer {
    margin-bottom: 16px;
  }
  .record{
    font-size: 14px;
    padding: 0 10px;
    line-height: 2
  }
  .records{
    max-height: 60vh;
    overflow: auto
  }
  .padding-span{
    padding-right:15px;
  }
  .total {
    margin-top: 12px;
    color: #1890ff;
  }
  .blue {
    color: #1890FF;
  }
</style>
